<template>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M31.9997 -6.86646e-05C33.828 -6.86646e-05 35.31 1.48202 35.31 3.31028V28.6896H60.6896C62.5178 28.6896 64 30.1718 64 32C64 33.8282 62.5178 35.3104 60.6896 35.3104H35.31V60.6897C35.31 62.5179 33.828 64.0001 31.9997 64.0001C30.1714 64.0001 28.6893 62.5179 28.6893 60.6897V35.3104H3.31035C1.48211 35.3104 0 33.8282 0 32C0 30.1718 1.48211 28.6896 3.31035 28.6896H28.6893V3.31028C28.6893 1.48202 30.1714 -6.86646e-05 31.9997 -6.86646e-05Z"
  />
</template>
